import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { inject } from '@angular/core';
import { PermissionService } from '../../shared/services/permissions.service';

/**
 * The workspace edit page hosts both workspace settings (CORE_WORKSPACE update) and the
 * permission UI (CORE_COMPANY manage.users — enforced separately inside the page).
 * PLATFORM_ADMIN is deliberately NOT a bypass: its login action only grants the MTM
 * Admin Console; admin accounts carry the CORE_* verbs in their /effective response.
 */
export const canActivateWorkspaceSettings: CanActivateFn = (): boolean | UrlTree => {
  const permissionService: PermissionService = inject(PermissionService);
  return (
    permissionService.canManageCompanyUsers() ||
    permissionService.canUpdateWorkspace() ||
    inject(Router).createUrlTree(['/projects'])
  );
};
